"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {

	var base = (0, _baseIndicator2.default)().type(ALGORITHM_TYPE).accessor(function (d) {
		return d.sar;
	});

	var underlyingAlgorithm = (0, _algorithm.sar)();

	var mergedAlgorithm = (0, _utils.merge)().algorithm(underlyingAlgorithm).merge(function (datum, indicator) {
		datum.sar = indicator;
	});

	var indicator = function indicator(data) {
		if (!base.accessor()) throw new Error("Set an accessor to " + ALGORITHM_TYPE + " before calculating");
		var newData = mergedAlgorithm(data);
		return newData;
	};
	indicator.undefinedLength = function () {
		return underlyingAlgorithm.windowSize();
	};

	base.tooltipLabel(function () {
		return ALGORITHM_TYPE + "(" + underlyingAlgorithm.windowSize() + ")";
	});

	(0, _d3fcRebind.rebind)(indicator, base, "id", "accessor", "stroke", "echo", "type", "tooltipLabel");
	(0, _d3fcRebind.rebind)(indicator, underlyingAlgorithm, "undefinedLength", "accelerationFactor", "maxAccelerationFactor");
	(0, _d3fcRebind.rebind)(indicator, mergedAlgorithm, "merge");

	return indicator;
};

var _d3fcRebind = require("d3fc-rebind");

var _utils = require("../utils");

var _algorithm = require("./algorithm");

var _baseIndicator = require("./baseIndicator");

var _baseIndicator2 = _interopRequireDefault(_baseIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALGORITHM_TYPE = "SMA";


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/indicator/sar.js
// module id = 908
// module chunks = 0